import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';
import { ParameterField } from './ParameterField';
import SelectField from '../../../_common/platform/tsx/SelectField';

interface IDataSourceSelectProperties {
    value?: number;
    options?: {
        hideTitle?: boolean;
        defaultName?: string;
        title?: string;
    };
    glob: IGlob;

    onChange?(value: number): void;
}

function processOnChange(props: IDataSourceSelectProperties, value: number) {
    props.glob.EntityModelsStore.storeDataSourceID(value);

    if (typeof props.onChange === 'function') {
        props.onChange(value);
    }
}

function getDefinedValue(props: IDataSourceSelectProperties) {
    let result = props.value;

    if (result == null) {
        const dataSources = props.glob.EntityModelsStore.getDataSources();
        const { options } = props;

        if (options != null && options.defaultName && dataSources != null && dataSources.length > 0) {
            const dataSource = dataSources.find((element) => {
                return element.name.toLowerCase().indexOf(options.defaultName) !== -1;
            });

            result = dataSource ? dataSource.dataSourceID : -1;
            processOnChange(props, result);
        }
    }

    return result;
}

function riseOnChangeWithStoredValue(props: IDataSourceSelectProperties) {
    let value = getDefinedValue(props);

    if (value == null) {
        value = props.glob.EntityModelsStore.getStoredDataSourceID();

        if (value != null) {
            processOnChange(props, value);
        }
    }
}

// EVG: Setting stored Datasource ID when the value is not set,
// demands rising onChange event with the new value, in order to update any depending components.
export function DataSourceSelect(props: IDataSourceSelectProperties) {
    props.glob.EntityModelsStore.useLoadDataSourcesHook();

    React.useEffect(() => {
        riseOnChangeWithStoredValue(props);
    }, [props.value]);

    const dataSources = props.glob.EntityModelsStore.getDataSources();

    if (dataSources.length === 0) {
        return null;
    }

    let value = getDefinedValue(props);

    if (value == null) {
        value = props.glob.EntityModelsStore.getStoredDataSourceID();
    }

    return (
        <div className="data-source-select-field">
            <ParameterField
                className="JEST-test"
                noTitle={props.options?.hideTitle}
                title={props.options?.title || 'Data Source'}
                clearable={false}
            >
                <SelectField
                    disabled={dataSources.length < 2}
                    value={value != null ? value.toString() : null}
                    options={{
                        values: _.pluck(dataSources, 'dataSourceID'),
                        display: _.pluck(dataSources, 'name')
                    }}
                    onChange={(value: string) => {
                        processOnChange(props, parseInt(value, 10));
                    }}
                />
            </ParameterField>
        </div>
    );
}

export default class DataSourceSelectField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static EditComponent = DataSourceSelect;

    constructor(glob: IGlob, title: string, validators?, defaultVal?, options?) {
        super(glob, title, [], validators, defaultVal, options);
    }
}
